import React, { useState, useEffect } from 'react';

const GOLD='#F5A623',DARK='#2C2C2A',NAVY='#1E3A5F',GREEN='#22C55E',RED='#EF4444';

export default function NFCPage() {
  const token = window.location.pathname.split('/nfc/')[1];
  const [status, setStatus] = useState('loading');
  const [action, setAction] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setError('Token NFC lipsă.'); return; }
    fetch('/api/public/nfc/' + token)
      .then(r => r.json())
      .then(data => {
        if (data.error) { setError(data.error); setStatus('error'); return; }
        setAction(data.action);
        if (data.action === 'login') {
          localStorage.setItem('token', data.token);
          localStorage.setItem('user', JSON.stringify(data.user));
          window.history.replaceState({}, '', '/');
          window.location.reload();
        } else if (data.action === 'vehicle') {
          window.location.href = '/masina/' + data.vehicle_token;
        } else {
          setStatus('ready');
        }
      })
      .catch(() => { setError('Eroare de conectare.'); setStatus('error'); });
  }, [token]);

  const wrap = {
    minHeight: '100vh',
    background: '#F4F4F4',
    fontFamily: "'Syne', sans-serif",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  };
  const card = {
    background: '#fff',
    border: '0.5px solid #D3D1C7',
    borderRadius: '14px',
    padding: '40px 32px',
    maxWidth: '420px',
    width: '100%',
    textAlign: 'center',
  };
  const btn = {
    padding: '13px 22px',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: 700,
    cursor: 'pointer',
    border: 'none',
    fontFamily: "'Syne', sans-serif",
    width: '100%',
    marginBottom: '10px',
  };

  if (status === 'loading') return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🏷️</div>
        <div style={{ fontWeight: 800, fontSize: '18px', marginBottom: '8px' }}>Se verifică tag-ul NFC...</div>
        <div style={{ fontSize: '13px', color: '#888' }}>Te rugăm să aștepți.</div>
      </div>
    </div>
  );

  if (status === 'error') return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
        <div style={{ fontWeight: 800, fontSize: '18px', marginBottom: '8px', color: RED }}>Tag NFC invalid</div>
        <div style={{ fontSize: '13px', color: '#888', marginBottom: '20px' }}>{error}</div>
        <button onClick={() => window.location.href = '/'} style={{ ...btn, background: DARK, color: '#fff' }}>
          ← Înapoi la dosarmasina.ro
        </button>
      </div>
    </div>
  );

  if (action === 'register') return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ background: DARK, width: '64px', height: '64px', borderRadius: '16px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
          <span style={{ color: GOLD, fontWeight: 900, fontSize: '22px' }}>EA</span>
        </div>
        <div style={{ fontWeight: 800, fontSize: '20px', marginBottom: '8px' }}>🏷️ Activează tag-ul NFC</div>
        <div style={{ fontSize: '13px', color: '#666', lineHeight: 1.6, marginBottom: '28px' }}>
          Acest tag nu este activat.<br/>
          Creează un cont pe <strong>dosarmasina.ro</strong> sau autentifică-te pentru a-l configura.
        </div>
        <div style={{ background: '#FEF3DC', border: '1px solid ' + GOLD, borderRadius: '10px', padding: '12px', fontSize: '12px', color: '#92400E', marginBottom: '24px' }}>
          📱 Odată activat, scanarea tag-ului NFC te va duce direct în contul tău sau la pagina mașinii tale.
        </div>
        <button
          onClick={() => { localStorage.setItem('pending_nfc_token', token); window.location.href = '/register?nfc_token=' + token; }}
          style={{ ...btn, background: GOLD, color: DARK }}
        >
          Creează cont gratuit →
        </button>
        <button
          onClick={() => { localStorage.setItem('pending_nfc_token', token); window.location.href = '/login?nfc_token=' + token; }}
          style={{ ...btn, background: '#F4F4F4', color: DARK, border: '0.5px solid #D3D1C7' }}
        >
          Am deja cont — Autentifică-te
        </button>
        <div style={{ fontSize: '11px', color: '#aaa', marginTop: '8px' }}>dosarmasina.ro · by Premium Support Iași</div>
      </div>
    </div>
  );

  return null;
}
